import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '../types/user';

interface UserState {
	user: any;
	isLoggedIn: boolean;
	token: string | null;
	setUser: (user: any | null) => void;
	setToken: (token: string | null) => void;
	login: (user: any, token: string) => void;
	logout: () => void;
	updatePoints: (points: number) => void;
	updateUserInfo: (info: any) => void;
	refreshUserData: () => Promise<void>;
}

export const useUserStore = create<UserState>()(
	persist(
		(set) => ({
			user: null,
			isLoggedIn: false,
			token: null,

			setUser: (user) => set({ user, isLoggedIn: !!user }),

			setToken: (token) => set({ token }),

			login: (user: any, token) =>
				set({
					user,
					token,
					isLoggedIn: true,
				}),

			logout: () =>
				set({
					user: null,
					token: null,
					isLoggedIn: false,
				}),

			updatePoints: (pointsToAdd) =>
				set((state) => ({
					user: state.user
						? { ...state.user, points: (state.user.points || 0) + pointsToAdd }
						: null,
				})),

			updateUserInfo: (info) =>
				set((state) => ({
					user: state.user ? { ...state.user, ...info } : null,
				})),

			refreshUserData: async () => {
				// 模拟API调用刷新用户数据
				await new Promise((resolve) => setTimeout(resolve, 500));
				set((state) => {
					if (state.user) {
						return {
							user: {
								...state.user,
								points: state.user.points + Math.floor(Math.random() * 10), // 模拟积分变化
								lastLoginTime: new Date().toISOString(),
							},
						};
					}
					return state;
				});
			},
		}),
		{
			name: 'user-storage',
		}
	)
);
